// extracted by mini-css-extract-plugin
export default {"pqrsResponse":"PQRsResponse_pqrsResponse__fXfSl","form":"PQRsResponse_form__MJaZD"};